import { Injectable } from '@angular/core';
import { ModalComponent } from './modal/modal.component';

@Injectable()
export class ModalService {

    private modals: ModalComponent[]= [];
    constructor() {}

    closeAll() {
        if (this.modals.length > 0) {
            this.modals.forEach(k => {
                // console.log(k.id);
                if (k.id != "modal-error") {
                    k.close();
                }
            })
        }
    }

    add(modal: ModalComponent) {
        // add modal to array of active modals
        this.modals.push(modal);
    }

    remove(id: string) {
        // remove modal from array of active modals
        this.modals = this.modals.filter(x => x.id !== id);
    }

    open(id: string) {
        const modalToOpen = this.modals.find(modal => modal.id === id);
        if (modalToOpen && !modalToOpen.isOpen) {
            modalToOpen.open();
        } else {
            console.warn(`Modal with id "${id}" does not exist or is already open.`);
        }
    
    }

    close(id: string) {
        const modalToClose = this.modals.find(modal => modal.id === id);
        if (modalToClose) {
            modalToClose.close();
        } else {
            console.warn(`Modal with id "${id}" does not exist.`);
        }
    }

}
